import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../App.css";
import { apiPostAuth } from "../../utils/api";

export default function ChangePasswordPage() {
  const navigate = useNavigate();

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!oldPassword || !newPassword || !confirmNewPassword) {
      alert("Please fill in all fields.");
      return;
    }

    if (newPassword !== confirmNewPassword) {
      alert("New passwords do not match.");
      return;
    }

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    if (!newPassword) {
        alert("New Password is required.");
        return;
    } else if (!passwordRegex.test(newPassword)) {
        alert("Password must be at least 8 characters, include uppercase, lowercase, and a number.");
        return;
    }

    try {
      setLoading(true);
      const response = await apiPostAuth("account/change_password.php", {
        old_password: oldPassword,
        new_password: newPassword,
      });


      if (response.result === 1) {
        alert("Password successfully updated.");
        navigate("/dashboard/account-settings");
      } else {
        alert(response.message || "Failed to change password.");
      }
    } catch (error) {
      alert("An error occurred while changing password.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <button
        onClick={() => navigate("/dashboard/account-settings")}
        style={backButtonStyle}
      >
        ← Back to Account Settings
      </button>

      <h1 style={{ fontSize: "1.8rem", marginBottom: "20px", color: "#1f2937" }}>
        Change Password
      </h1>

      <form onSubmit={handleChangePassword} style={formContainerStyle}>
        <div style={formGroupStyle}>
          <label style={labelStyle}>Old Password</label>
          <input
            type={showPassword ? "text" : "password"}
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            className="input-field"
            required
          />
        </div>

        <div style={formGroupStyle}>
          <label style={labelStyle}>New Password</label>
          <input
            type={showPassword ? "text" : "password"}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="input-field"
            required
          />
        </div>

        <div style={formGroupStyle}>
          <label style={labelStyle}>Confirm New Password</label>
          <input
            type={showPassword ? "text" : "password"}
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            className="input-field"
            required
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <input
            type="checkbox"
            checked={showPassword}
            onChange={() => setShowPassword(!showPassword)}
            id="showPassword"
          />
          <label htmlFor="showPassword" style={{ marginLeft: "8px", color: "#4b5563" }}>
            Show Passwords
          </label>
        </div>

        <button
          type="submit"
          className="primary-button"
          disabled={loading}
          style={{ width: "100%", opacity: loading ? 0.6 : 1 }}
        >
          {loading ? "Updating..." : "Change Password"}
        </button>
      </form>
    </div>
  );
}

/* --- Styles --- */
const formContainerStyle = {
  backgroundColor: "#fff",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  maxWidth: "400px",
};

const formGroupStyle = {
  marginBottom: "15px",
};

const labelStyle = {
  display: "block",
  marginBottom: "6px",
  fontWeight: "500",
  fontSize: "0.95rem",
  color: "#1f2937",
};

const backButtonStyle = {
  display: "inline-block",
  padding: "8px 16px",
  backgroundColor: "#f2f6fc",
  color: "#2563eb",
  fontWeight: "500",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "20px",
  transition: "all 0.2s ease",
};
